<textarea
  pTextarea
  [formErrorDirective]="formName"
  tabindex="{{ tabIndex }}"
  [formControl]="control"
  [placeholder]="placeholder ? placeholder : name"
  [rows]="numRows"
  [disabled]="disabled"
  [class]="'form-control ' + fontStyle"
></textarea>
